exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7b335bae] .el-table{font-size:13px}[data-v-7b335bae] .el-table .cell{line-height:14px}", ""]);

// exports
